import { Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useWebphoneStore } from '@/stores/webphoneStore';

export const WebphoneButton: React.FC = () => {
  const { t } = useTranslation();
  const { isOpen, toggle } = useWebphoneStore();

  return (
    <button
      type="button"
      onClick={toggle}
      title={t('webphone.toggle', 'Webphone')}
      aria-label={t('webphone.toggle', 'Webphone')}
      aria-pressed={isOpen}
      className={`flex items-center justify-center p-1.5 rounded-full transition-all duration-200
        ${isOpen
          ? 'bg-brand-500 text-white shadow-sm'
          : 'text-text-700 hover:bg-neutral-100 active:bg-neutral-200 dark:text-neutral-400 dark:hover:bg-neutral-700 dark:active:bg-neutral-600'
        }`}
    >
      <Phone className="h-5 w-5" />
    </button>
  );
};
